import React from 'react';
import Router from './router';
import './App.css';
import Styles from './components/common/styles/styles';
import { UserProvider } from './userContext';
import { SimulatorProvider } from './simulatorContext';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css'; 

Styles.textFieldStyles = {
    '& .MuiInputLabel-root': { color: 'white' },
    '& .MuiOutlinedInput-root': {
        color: 'white',
        '& fieldset': { borderColor: 'gray' },
        '&:hover fieldset': { borderColor: 'gray' },
        '&.Mui-focused fieldset': { borderColor: 'gray' },
        '&.Mui-error fieldset': { borderColor: '#f44336' },
    },
    '& .MuiFormHelperText-root': {
        color: '#f44336'
    },
    '& .MuiSvgIcon-root': {
        color: 'gray', 
    },
    '& .MuiInputBase-input': {
      '&:-webkit-autofill, &:-webkit-autofill:hover, &:-webkit-autofill:focus, &:-webkit-autofill:active': {
        WebkitTextFillColor: '#FFFFFF !important',
        WebkitBoxShadow: '0 0 0 100px transparent',
        transition: 'background-color 5000s ease-in-out 0s',
      },
    },
    /* Text color when focused */
    '& .MuiInputBase-input:focus': {
      color: '#ffffff',
    },
};

Styles.dateFieldStyles = {
    variant: 'outlined',
    '& .MuiInputLabel-root': { color: 'white' },
    '& .MuiOutlinedInput-root': { color: 'white' },
    '& .MuiSvgIcon-root': { color: '#9d8a8a' },
    '& .MuiPickersOutlinedInput': { color: 'white' },
    '& .MuiPickersInputBase-colorPrimary': { color: 'white' },
};

Styles.modalStyle = {
  overlay: {
    backgroundColor: '#080030', // Semi-transparent black
  },
  content: {
    backgroundColor: '#080030',
  },
};

Styles.buttonStyle = {
    bgcolor: '#303F9F',
    textTransform: 'none',
    alignSelf: 'flex-start',
    mt: 1,
    '&:hover': {
      bgcolor: '#303F9F',
    },
    '&:disabled': {
      bgcolor: 'rgba(140, 165, 242, 0.12)',
      color: '#FFF',
    },
    width: '47%',
};

Styles.phenTextStyle = {
    // Change the actual input text color
    '& .MuiInputBase-input': {
        color: 'white', // The color of the text you type
    },
    // Change the label color
    '& .MuiInputLabel-root': {
        color: 'white',
    },
    // Change the label color when focused
    '& .MuiInputLabel-root.Mui-focused': {
        color: 'white',
    },
    // Change the border color
    '& .MuiOutlinedInput-root': {
        '& fieldset': {
            borderColor: 'white',
        },
        '&:hover fieldset': {
            borderColor: 'white',
        },
        '&.Mui-focused fieldset': {
            borderColor: 'white',
        },
      }
};

export default function App() {

  return (
    <>
      <main className="app-container app-content">
          <UserProvider>
            <SimulatorProvider>
              <Router />
              <ToastContainer />
            </SimulatorProvider>
          </UserProvider>        
      </main>
    </>
  );
}
